<template>
    <div>
        <InitialLoading :init-loading='initialLoading' />
        <v-container v-if='!initialLoading' class='active-package'>

            <div class='mb-4'>
                <div class='subtitle-1 mb-3'>
                    <v-icon class='ml-1'>mdi-gift-outline</v-icon>
                    <span>بسته های پیشنهادی</span>
                </div>
                <v-row>
                    <v-col cols='12'
                           sm='6'
                           md='4'
                           v-for='bundle in bundles'
                           :key='bundle._id'
                    >
                        <v-card>
                            <v-card-title class=''>{{ bundle.title }}</v-card-title>
                            <v-card-subtitle>
                                <span :class="{'text-decoration-line-through':!!bundle.off}">{{ bundle.price.toLocaleString() + ' تومان ' }}</span>
                                <span  class="mr-3" v-if="!!bundle.off">{{ (bundle.price-(bundle.price * bundle.off /100)).toLocaleString() + ' تومان ' }}</span>
                            </v-card-subtitle>
                            <v-divider class='mx-2' />
                            <v-card-text>
                                <v-list dense v-if='bundle.paidFeatures.length > 0'>
                                    <v-list-item
                                        v-for='item in bundle.paidFeatures'
                                        :key='item.key'
                                    >
                                        <v-list-item-content>
                                            {{ item.title }}
                                        </v-list-item-content>
                                        <v-list-item-content>
                                            {{ item.count }}
                                        </v-list-item-content>
                                    </v-list-item>
                                </v-list>
                            </v-card-text>
                            <v-divider class='mx-2' />
                            <v-card-actions class='d-flex align-center justify-space-between'>
                                <v-btn
                                    color='primary'
                                    dark
                                    :loading='loadingCreateNewInvoice'
                                    @click='createInvoiceForBuyBundle(bundle)'
                                >
                                    صدور صورتحساب
                                </v-btn>
                                <v-btn
                                    outlined
                                    color='primary'
                                    :disabled='loadingCreateNewInvoice || wallet.amount < bundle.price'
                                    @click='createInvoiceForBuyBundleAndPayByWallet(bundle)'
                                >
                                    پرداخت با کیف پول
                                </v-btn>

                            </v-card-actions>
                        </v-card>
                    </v-col>
                </v-row>
            </div>

            <v-card v-if='paidFeature'>
                <v-card-title>
                    فعال سازی گزینه
                    {{ paidFeature.title }}
                </v-card-title>
                <v-card-text>
                    <div v-for='item in packages' :key='item._id'
                         class='d-flex align-center justify-space-between flex-row mb-2'>
                        <div> {{ item.count }} عددی</div>
                        <div v-if="!!item.off" class='text-right'>
                            <span :class="{'text-decoration-line-through':!!item.off}">{{ item.amount.toLocaleString() + ' تومان ' }}</span>
                            <span class="mr-3">{{ (item.amount-(item.amount * item.off /100)).toLocaleString() + ' تومان ' }}</span>
                        </div>
                        <div v-else class='text-right'>{{ item.amount.toLocaleString() + ' تومان' }}</div>
                        <div class='text-center'>
                            <v-btn
                                class='ml-2'
                                color='primary'
                                dark
                                :loading='loadingCreateNewInvoice'
                                @click='createInvoiceForBuyPackage(item)'
                            >
                                صدور صورتحساب
                            </v-btn>
                            <v-btn
                                outlined
                                color='primary'
                                :disabled='loadingCreateNewInvoice || wallet.amount < item.amount'
                                @click='createInvoiceForBuyPackageAndPayByWallet(item)'
                            >
                                پرداخت با کیف پول
                            </v-btn>
                        </div>
                    </div>
                </v-card-text>

            </v-card>

        </v-container>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import axios from 'axios';
    import InitialLoading from '@/components/initialLoading';

    export default {
        name: 'ActivePackage',
        components: { InitialLoading },
        data() {
            return {
                initialLoading: true,
                loadingCreateNewInvoice: false,

                featureKey: null,


                paidFeature: {},
                packageInfo: null,

                bundles: [],
                packages: [],

                cbUrl: null,
                ad: null
            };
        },

        methods: {
            goBack() {
                this.$store.commit('goBack');
                this.$router.replace(this.$store.state.history.page);
            },

            async fetchBundlesData() {
                await axios
                    .get(`/api/bundles`)
                    .then(res => {
                        this.bundles = res.data.bundles;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },
            async fetchPackagesData() {
                await axios
                    .get(`/api/packages/${this.featureKey}`)
                    .then(res => {
                        this.paidFeature = res.data.paidFeature;
                        this.packages = res.data.packages;
                    })
                    .catch(err => {
                        console.error(err);
                    });
            },

            async payInvoiceByWallet(invoice_id) {
                await axios
                    .post(`/api/invoices/${invoice_id}/pay_by_wallet`)
                    .then(res => {
                        const { wallet, invoice } = res.data;
                        this.setWallet(wallet);

                        this.$snackbar.showMessage({
                            content: 'صورت حساب شما با موفقیت پرداخت شد',
                            color: 'success',
                            timeout: 3000
                        });

                        this.$router.replace(invoice.clientCallback);
                    })
                    .catch(err => {
                        console.error(err);
                        this.$error.showError(err.response);
                    });
            },

            async createInvoiceForBuyBundleAndPayByWallet(item) {
                await this.createInvoiceForBuyBundle(item, await this.payInvoiceByWallet);
            },
            async createInvoiceForBuyPackageAndPayByWallet(item) {
                await this.createInvoiceForBuyPackage(item, await this.payInvoiceByWallet);
            },

            async createInvoiceForBuyBundle(item, callback) {
                this.loadingCreateNewInvoice = true;
                await axios
                    .post(`/api/invoices`, {
                            invoiceFor: 'BUNDLE',
                            bundle_id: item._id,
                            clientCallback: this.cbUrl
                        }
                    )
                    .then(async res => {
                        if (callback) {
                            await callback(res.data.invoice_id);
                            this.loadingCreateNewInvoice = false;
                        } else {
                            this.$router.push({
                                name: 'Invoice',
                                params: { invoice_id: res.data.invoice_id },
                                query: { ref_path: 'buyFeature' }
                            });
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        this.loadingCreateNewInvoice = false;
                        this.$error.showError(err.response);
                    });
            },
            async createInvoiceForBuyPackage(item, callback) {
                this.loadingCreateNewInvoice = true;
                await axios
                    .post(`/api/invoices`, {
                            invoiceFor: 'PACKAGE',
                            package_id: item._id,
                            clientCallback: this.cbUrl
                        }
                    )
                    .then(async res => {
                        if (callback) {
                            await callback(res.data.invoice_id);
                            this.loadingCreateNewInvoice = false;
                        } else {
                            this.$router.push({
                                name: 'Invoice',
                                params: { invoice_id: res.data.invoice_id },
                                query: { ref_path: 'buyFeature' }
                            });
                        }
                    })
                    .catch(err => {
                        console.error(err);
                        this.loadingCreateNewInvoice = false;
                        this.$error.showError(err.response);
                    });
            },

            ...mapActions(['setWallet', 'showBreadCrumbs', 'setBreadCrumbsTemp'])
        },
        async created() {
            this.cbUrl = this.$route.query.cbUrl || null;
            this.featureKey = this.$route.params.paidFeature_key;
            this.ad = this.$route.params.ad_id;
//            this.bundle_id = this.$route.query.bundle_id || null;
//            this.package_id = this.$route.query.package_id || null;

            await this.fetchPackagesData();
            await this.fetchBundlesData();

            this.initialLoading = false;
            let href = window.location.pathname + window.location.search;
            await this.setBreadCrumbsTemp({
                key: 'buyFeature',
                value: {
                    text: `خرید بسته`,
                    href: href
                }
            });
        },
        async updated() {
            await this.showBreadCrumbs(['home', 'buyFeature']);
        },
        computed: {
            ...mapState(['wallet', 'translate'])
        }
    };
</script>

<style scoped lang='scss'>
    .active-package {
        /* the slides */
        :deep().slick-slide {
            margin: 0 10px;
        }
    }

</style>